import React from 'react';
import { Button } from 'semantic-ui-react';

const UploadButton = ({ children, ...rest }) => (
  <Button
    type='button'
    className='reactCrop_uploadBtn'
    primary
    {...rest}
  >
    {children}
  </Button>
);

export default UploadButton;



// WEBPACK FOOTER //
// ./src/components/uploader/UploadButton.js